import { Fragment, useEffect, useState } from "react";
import { createDateBinning, projectTotal } from "../../services/baseplateService";

import { CumulativeNew, RateNew, createDepsList, castToCumulativePlot, castToRatePlot, ControlPanel } from "../common/MetricPlots";

export const PreFlatness = () => {
  // Form for toggling the display
  const [stacked, setStacked] = useState(true);
  const [timeAll, setTimeAll] = useState(false);
  const [countAll, setCountAll] = useState(false);
  const [mod, setMod] = useState(0);
  const [target, setTarget] = useState(0);

  const selectDisplay = {
    "CuW Full": { state: useState(true), types: ["F0W", "FLW", "FHW"], target: projectTotal("FLW") + projectTotal("FHW") },
    "CuW LD Left/Right": { state: useState(true), types: ["SLW", "LLW", "RLW"], target: projectTotal("LLW") + projectTotal("RLW") },
    "CuW LD Top": { state: useState(true), types: ["TLW"], target: projectTotal("TLW") },
    "CuW LD Bottom": { state: useState(true), types: ["BLW"], target: projectTotal("BLW") },
    "CuW LD Five": { state: useState(true), types: ["5LW"], target: projectTotal("5LW") },
    "CuW HD Left/Right": { state: useState(true), types: ["SHW", "LHW", "RHW"], target: projectTotal("LHW") + projectTotal("RHW") },
    "CuW HD Bottom": { state: useState(true), types: ["BHW"], target: projectTotal("BHW") },
    "Ti Full": { state: useState(true), types: ["F0T", "FLT", "FHT"], target: projectTotal("FLT") + projectTotal("FHT") },
    "Ti LD Left": { state: useState(true), types: ["LLT"], target: projectTotal("LLT") },
    "Ti LD Right": { state: useState(true), types: ["RLW"], target: projectTotal("RLW") },
    "Ti LD Top": { state: useState(true), types: ["TLT"], target: projectTotal("TLT") },
    "Ti LD Bottom": { state: useState(true), types: ["BLT"], target: projectTotal("BLT") },
    "Ti LD Five": { state: useState(true), types: ["5LT"], target: projectTotal("5LT") },
    "Ti HD Top": { state: useState(true), types: ["THT"], target: projectTotal("THT") },
  }

  const catDisplay = {
    "unknown": { name: "unknown", color: "#AAA", state: useState(true) },
    "red": { name: "Grade C", color: "#880000", state: useState(true) },
    "orange": { name: "Grade B", color: "#886600", state: useState(true) },
    "green": { name: "Grade A", color: "#008800", state: useState(true) },
  }

  const [dataSum, setDataSum] = useState([]);
  const [dataRate, setDataRate] = useState([]);

  useEffect(() => {
    const allowedTypes = [];
    let tar = 0;
    Object.values(selectDisplay).forEach((value) => {
      if (value.state[0]) {
        value.types.forEach((x) => allowedTypes.push(x));
        tar += value.target;
      }
    })
    setTarget(tar);
    setMod((m) => m + 1);
    createDateBinning(allowedTypes, "preqc_date", "flatness_bare_grade", "hour").then((data) => {
      setDataSum(castToCumulativePlot(data));
    });
    createDateBinning(allowedTypes, "preqc_date", "flatness_bare_grade", "week").then((data) => {
      setDataRate(castToRatePlot(data));
    });

    // eslint-disable-next-line
  }, createDepsList(selectDisplay));

  return <Fragment>
    <ControlPanel
      stackState={[stacked, setStacked]}
      timeZoom={[timeAll, setTimeAll]}
      countZoom={[countAll, setCountAll]}
      setMod={setMod}
      selectDisplay={selectDisplay}
      catDisplay={catDisplay}
    />
    <hr />
    <CumulativeNew
      showStacked={stacked}
      timeZoom={timeAll}
      countZoom={countAll}
      keyState={[mod, setMod]}
      dataTable={dataSum}
      catDisplay={catDisplay}
      target={target}
      downloadPrefix="flatness_bare" />
    <hr />
    <RateNew
      showStacked={stacked}
      timeZoom={timeAll}
      keyState={[mod, setMod]}
      dataTable={dataRate}
      catDisplay={catDisplay}
      downloadPrefix="flatness_bare" />
  </Fragment >
}

export default PreFlatness;

